module.exports = __webpack_public_path__ + "static/media/Layout29.e30500f9.png";